import $ from 'jquery';

$('#industry-filter').change(function (){
    const value = $(this).val();
    if(value === ''){
        $('li.project').show();
        return;
    }
    $('li.project:not(.' + value +  ')').hide();
    $('li.project.' + value ).show();
})
